import LoadingState from "../../consts/LoadingState"

const state = () => ({
	loading: LoadingState.NOT_LOADING,
	loadingMessage: null,
	error: null,
	result: null
})

// getters
const getters = {
}

// actions
const actions = {
	START_LOADING({ commit }, message) {
		commit("LOADING_STATE", LoadingState.LOADING)
		commit("LOADING_MSG", message)
	},
	END_LOADING({ commit }) {
		commit("LOADING_STATE", LoadingState.NOT_LOADING)
		commit("LOADING_MSG", null)
	},
	LOADING_SUCCESS({ commit }, result) {
		commit("LOADING_STATE", LoadingState.SUCCESS)
		commit("LOADING_MSG", null)
		commit("SET_ERROR", null)
		commit("SET_RESULT", result)
	},
	SET_ERROR({ commit }, error) {
		commit("LOADING_STATE", LoadingState.ERROR)
		commit("LOADING_MSG", null)
		commit("SET_ERROR", error)
	},
	RESET_ERROR({ commit }) {
		commit("LOADING_STATE", LoadingState.NOT_LOADING)
		commit("LOADING_MSG", null)
		commit("SET_ERROR", null)
	}
}

// mutations
const mutations = {
	LOADING_STATE(state, value) {
		state.loading = value
	},
	SET_ERROR(state, error) {
		state.error = error
	},
	SET_RESULT(state, result) {
		state.result = result
	},
	LOADING_MSG(state, msg) {
		state.loadingMessage = msg || null
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}